import { Popover } from '@headlessui/react';
import { useState } from 'react';
import { HiInformationCircle } from 'react-icons/hi';
import { usePopper } from 'react-popper';

interface Props {
  children: React.ReactNode;
}

function InfoTooltip({ children }: Props): JSX.Element {
  const [referenceElement, setReferenceElement] =
    useState<HTMLButtonElement | null>();
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>();
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'top',
    modifiers: [
      {
        name: 'offset',
        options: { offset: [0, 8] },
      },
    ],
  });

  return (
    <Popover className="flex">
      <Popover.Button ref={setReferenceElement}>
        <HiInformationCircle className="h-5 w-5 text-gray-300" />
      </Popover.Button>

      <Popover.Panel
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
        className="max-w-[230px] rounded-lg border border-gray-200 bg-gray-700 px-3 py-2 text-sm font-normal text-white shadow-sm"
      >
        {children}
        <div className="relative">
          <span className="absolute left-[50%] h-[10px] w-[10px] translate-x-[-50%] rotate-45 bg-gray-700" />
        </div>
      </Popover.Panel>
    </Popover>
  );
}

export default InfoTooltip;
